import {DomainNameEnum} from '../../../../../../provider/domain-config/domain-config-type';
import {LangKeyType} from '../../../../../../provider/locale/translation/type';
import {ConcordanceAiPresetEnum} from '../../../../../../service/reivew-analysis/review-analysis-ai-chat/review-analysis-ai-message-type';

/**
 * Resolves the AI assistant display name for the current domain.
 *
 * White-label sites must never expose the RocketData brand, so they show a neutral "GPT".
 * The BrandWizard white-label keeps its own "WizardGPT" branding, hence it is checked first.
 */
export function getReviewsAiAssistantName(domainName: DomainNameEnum | string, isWhiteLabel: boolean): string {
    if (domainName === DomainNameEnum.brandWizard) {
        return 'WizardGPT';
    }

    if (isWhiteLabel) {
        return 'GPT';
    }

    return 'RocketGPT';
}

export const aiAnalysisPresetsTranslationKeys: Record<ConcordanceAiPresetEnum, LangKeyType> = {
    [ConcordanceAiPresetEnum.SWOT]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__SWOT',
    [ConcordanceAiPresetEnum.NEGATIVE_EXPERIENCE]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__NEGATIVE_EXPERIENCE',
    [ConcordanceAiPresetEnum.POSITIVE_EXPERIENCE]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__POSITIVE_EXPERIENCE',
    [ConcordanceAiPresetEnum.CLIENT_REQUESTS]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__CLIENT_REQUESTS',
    [ConcordanceAiPresetEnum.NEGATIVE_REVIEWS_THEMES]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__NEGATIVE_REVIEWS_THEMES',
    [ConcordanceAiPresetEnum.POSITIVE_REVIEWS_THEMES]: 'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__POSITIVE_REVIEWS_THEMES',
    [ConcordanceAiPresetEnum.EMOTIONAL_TONE_OF_REVIEWS]:
        'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__EMOTIONAL_TONE_OF_REVIEWS',
    [ConcordanceAiPresetEnum.STAFF_MENTIONS_AND_FEEDBACK]:
        'REVIEWS_ANALYSIS__AI_ANALYSIS__PRESET__STAFF_MENTIONS_AND_FEEDBACK',
};
